import { render, staticRenderFns } from "./SearchesList.vue?vue&type=template&id=b2f5db78&scoped=true&"
import script from "./SearchesList.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchesList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SearchesList.vue?vue&type=style&index=0&id=b2f5db78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f5db78",
  null
  
)

export default component.exports